import { NumberInput } from 'carbon-components-react';
import React, { MutableRefObject, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from 'src/apps/maas360-estimator/locales/messages';
import { segmentsTracking } from 'src/common/lib/tracker';

type Step4Props = {
  que4Value: number;
  setQue4Value: React.Dispatch<React.SetStateAction<number>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
};

const Step4 = ({ que4Value, setQue4Value, setIsRequired }: Step4Props) => {
  const deviceRef = useRef() as MutableRefObject<HTMLInputElement>;
  useEffect(() => {
    if (Number(que4Value) !== 0) {
      setIsRequired(false);
    } else {
      setIsRequired(true);
    }
  }, [que4Value]);

  return (
    <div>
      <label className="page_sub_heading padding_8">
        <FormattedMessage {...messages.que4_text_desc} />
      </label>
      <p>
        <FormattedMessage {...messages.que4_short_desc} />
      </p>
      <div className="number-input">
        <NumberInput
          id="Q4"
          size="md"
          ref={deviceRef}
          allowEmpty={true}
          name="Q4"
          helperText="Please add numbers of devices"
          min={0}
          max={50000}
          step={10}
          value={que4Value ? que4Value : ''}
          invalidText="Please provide a number between 1-50000"
          onChange={() => {
            if (deviceRef.current.value === '') {
              setIsRequired(true);
            } else {
              setQue4Value(parseInt(deviceRef.current.value));
              segmentsTracking('CTA Clicked', {
                pageTitle: 'MaaS360 Plan Assessment',
                object: 'Mass360 page',
                resultValue: 'CTA clicked',
                CTA: `question 4 - ${parseInt(
                  deviceRef.current.value,
                )} - selected`,
                location: 'Assessment',
                action: '',
                field: '',
              });
              setIsRequired(false);
            }
          }}
        />
      </div>
    </div>
  );
};

export default Step4;
